import React from "react";
import { ClinicProvider } from "../context/ClinicContext";

export default function ClinicSetupLayout({ children }) {
  return <ClinicProvider>{children}</ClinicProvider>;
}
